import React from 'react';
import {mapExposureColor} from "../utils";
import NivoBarChart from "../../../../../charts/nivo/NivoBarChart";



const ExposureBarChart = ({ maxExposureData }) => {
    let colors = {}
    const barChartData = maxExposureData.map(item => {
        colors[item.x] = mapExposureColor(item.value)
        return {id: item.x, [item.x]: parseFloat(item.value)}
  });
  const keys = maxExposureData.map(item => item.x);

  return (
      <div style={{height: '400px', width: '100%'}}>
        <NivoBarChart
            data={barChartData}
            keys={keys}
            customColors={colors}
            vertical={true}
            barPadding={0.3}
            rotateLabels={90}
            mode={'stacked'}
            legendSize={'small'}
        />
      </div>
  )

};

export default ExposureBarChart;
